import validate from "/opt/baserow/web-frontend/node_modules/nuxt/dist/pages/runtime/validate.js";
import authentication from "/opt/baserow/web-frontend/modules/core/middleware/authentication.js";
import manifest_45route_45rule from "/opt/baserow/web-frontend/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  authentication,
  manifest_45route_45rule
]
export const namedMiddleware = {
  settings: () => import("/opt/baserow/web-frontend/modules/core/middleware/settings.js"),
  authenticated: () => import("/opt/baserow/web-frontend/modules/core/middleware/authenticated.js"),
  workspacesAndApplications: () => import("/opt/baserow/web-frontend/modules/core/middleware/workspacesAndApplications.js"),
  pendingJobs: () => import("/opt/baserow/web-frontend/modules/core/middleware/pendingJobs.js"),
  staff: () => import("/opt/baserow/web-frontend/modules/core/middleware/staff.js"),
  impersonate: () => import("/opt/baserow/web-frontend/modules/core/middleware/impersonate.js"),
  urlCheck: () => import("/opt/baserow/web-frontend/modules/core/middleware/urlCheck.js"),
  tableLoading: () => import("/opt/baserow/web-frontend/modules/database/middleware/tableLoading.js"),
  selectWorkspaceDatabaseTable: () => import("/opt/baserow/web-frontend/modules/database/middleware/selectWorkspaceDatabaseTable.js"),
  dashboardLoading: () => import("/opt/baserow/web-frontend/modules/dashboard/middleware/dashboardLoading.js"),
  selectWorkspaceBuilderPage: () => import("/opt/baserow/web-frontend/modules/builder/middleware/selectWorkspaceBuilderPage.js")
}